<template>
  <li
    aria-hidden="true"
    class="d-list-item-separator"
  />
</template>

<script>
export default {
  compatConfig: { MODE: 3 },
  name: 'DtDropdownSeparator',
};
</script>
